import type { BaseFilesRepository } from "./BaseFilesRepository.interface";

import { localApiBase } from "../../../lib/localApi";

class ApiFilesRepository implements BaseFilesRepository {
  // Resuelta en cada llamada. En un worker no hay localStorage: el helper cae al
  // puerto por defecto, que es lo que este constructor hacía a mano.
  private get Domain(): string {
    return localApiBase();
  }

  async readFile(directory: string, fileName: string): Promise<Blob | null> {
    try {
      const filePath = encodeURIComponent(`${directory}${fileName}`);

      const url = `${this.Domain}/api/files?file_path=${filePath}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (response.status === 204) {
        return null;
      }

      if (!response.ok) {
        return null;
      }

      const blob = await response.blob();

      return blob;
    } catch (error) {
      console.error("❌ Error en readFile:", error);

      return null;
    }
  }

  async uploadFile(
    directory: string,

    fileName: string,

    file: Blob,

    onProgress?: (progress: number) => void,
  ) {
    const formData = new FormData();

    formData.append("file", file);

    formData.append("filename", fileName);

    formData.append("dir_path", directory);

    if (!onProgress) {
      const { status } = await fetch(`${this.Domain}/api/files`, {
        method: "POST",

        body: formData,
      });

      return status === 200;
    }

    return new Promise<boolean>((resolve) => {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${this.Domain}/api/files`);

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);

          onProgress(percent);
        }
      });

      xhr.addEventListener("load", () => {
        resolve(xhr.status === 200);
      });

      xhr.addEventListener("error", () => {
        resolve(false);
      });

      xhr.send(formData);
    });
  }

  async createDirectory(directoryPath: string) {
    try {
      const response = await fetch(`${this.Domain}/api/directories`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({ dir_path: directoryPath }),
      });

      return response.ok;
    } catch (error) {
      console.error("❌ Error creating directory:", error);

      return false;
    }
  }
}

export default ApiFilesRepository;
